export const REGISTRATION_CONFIRM_PATH = '/confirm-registration';
export const REGISTRATION_CONFIRM_CODE_PARAM = 'code';
export const REGISTRATION_CONFIRM_STATUS_PARAM = 'registrationConfirm';

export type RegistrationConfirmStatus = 'success' | 'error';

export function readRegistrationConfirmCode(searchParams: URLSearchParams): string | null {
    const code = searchParams.get(REGISTRATION_CONFIRM_CODE_PARAM)?.trim() ?? '';
    return code || null;
}

export function readRegistrationConfirmStatus(searchParams: URLSearchParams): RegistrationConfirmStatus | null {
    const status = searchParams.get(REGISTRATION_CONFIRM_STATUS_PARAM);
    return status === 'success' || status === 'error' ? status : null;
}

/** Prefix for Club Manager registration confirmation emails; CRM appends the urlCode. */
export function buildRegistrationConfirmationUrl(publicOrigin: string): string {
    return `${publicOrigin.replace(/\/$/, '')}${REGISTRATION_CONFIRM_PATH}/?${REGISTRATION_CONFIRM_CODE_PARAM}=`;
}

export function buildRegistrationConfirmHomeRedirect(status: RegistrationConfirmStatus): string {
    return `/?${REGISTRATION_CONFIRM_STATUS_PARAM}=${status}`;
}
